import * as ActionTypes from './action-types.constants';

export const expand = (linkEl) => ({
	type: ActionTypes.EXPAND
})

export const collapse = (linkEl) => ({
	type: ActionTypes.COLLAPSE
})
